import { useState, useCallback, useEffect } from "react";
import { post } from "../networking/RequestService";
import { toast } from "react-toastify";
import { apiErrorText } from "app/popleads/networking/apiErrorText";

const useGetDealPaymentsByDealId = (dealId) => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [payments, setPayments] = useState([]);

    const getDealPayments = useCallback(async () => {
        if (!dealId) {
            toast.error("Deal ID is required.");
            return;
        }

        setLoading(true);
        setError(null);
        try {
            const response = await post({
                fn: "getDealPaymentsByDealId",
                dealId: dealId,
            });
            setPayments(response.data.payments || []);
            return response.data.payments;
        } catch (err) {
            toast.error(apiErrorText(err));
            setError(err);
            throw err;
        } finally {
            setLoading(false);
        }
    }, [dealId]);

    useEffect(() => {
        if (dealId) {
            getDealPayments();
        }
    }, [dealId, getDealPayments]);

    return { loading, error, payments, getDealPayments };
};

export default useGetDealPaymentsByDealId;
